export default function Spinner() {
  return <div className={`h-6 w-6 animate-spin-fast rounded-full border-2 border-gray-100 border-t-transparent`} />
}
